export const VIDEO_INPUT = 'videoinput';
export const AUDIO_INPUT = 'audioinput';
